import React, { useEffect, useState } from "react";

const QuestCreationSuccessModal = ({ isOpen, onClose }) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => setShowButton(true), 1800);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white rounded-[2rem] shadow-2xl w-[90%] max-w-[480px] p-8 text-center relative overflow-hidden animate-[popUp_0.35s_ease-out]">

        {/* Brain Icon */}
        <div className="text-[3rem] mb-2 animate-bounce">🧠</div>

        {/* Title */}
        <h2 className="text-3xl font-bold text-[#222] font-inter mb-2">Quest Created!</h2>
        <p className="text-sm text-gray-600 font-inter mb-6">
          Your quest is live — let the minds begin to spark.
        </p>

        {/* Checkmark */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
            <span className="text-green-500 text-3xl">✔</span>
          </div>
        </div>

        {/* Button */}
        {showButton && (
          <button
            onClick={onClose}
            className="mt-2 px-6 py-2 rounded-full bg-black text-white font-semibold font-inter text-sm hover:bg-neutral-800 transition-all active:scale-95"
          >
            Got it!
          </button>
        )}

        {/* Background Icons */}
        <div className="absolute -top-10 -left-8 text-[4rem] animate-spin-slow">🧩</div>
        <div className="absolute -bottom-10 -right-8 text-[4rem] animate-spin-slow-reverse">📜</div>

        {/* Animation Keyframes */}
        <style>{`
          @keyframes popUp {
            0% { transform: scale(0.85); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }

          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          @keyframes spin-slow-reverse {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(-360deg); }
          }

          .animate-spin-slow {
            animation: spin-slow 12s linear infinite;
          }

          .animate-spin-slow-reverse {
            animation: spin-slow-reverse 10s linear infinite;
          }
        `}</style>
      </div>
    </div>
  );
};

export default QuestCreationSuccessModal;
